<template>
    <div class="container">
        <menu-list></menu-list>
        <div class="main">
            <div class="main-content">
                <div class="main-left ">
                    <div class="user-img boxshadow2">
                        <img :src="ConstPersonal.sellerImage" alt="" width="92" height="92">
                        <span class="seller">
                            {{ConstPersonal.seller}}
                        </span>
                        <span class="time">
                            {{new Date().$Format('yyyy-MM-dd hh:mm:ss')}}
                        </span>
                    </div>
                    <div class="user-info boxshadow2">
                        <div>
                            <span class="label">
                                学校
                            </span>
                            <span class="value">
                                {{ConstPersonal.school}}
                            </span>
                        </div>
                        <div>
                            <span class="label">
                                班级
                            </span>
                            <span class="value">
                                {{ConstPersonal.clazz}}
                            </span>
                        </div>
                        <div>
                            <span class="label">
                                学号
                            </span>
                            <span class="value">
                                {{ConstPersonal.studentNo}}
                            </span>
                        </div>
                        <div>
                            <span class="label">
                                卖家昵称
                            </span>
                            <span class="value">
                                {{ConstPersonal.seller}}
                            </span>
                        </div>
                        <div>
                            <span class="label">
                                买家昵称
                            </span>
                            <span class="value">
                                {{ConstPersonal.buyer}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="main-right">
                    <div class="basics-section boxshadow2">
                        <div class="basics-section-main">
                            <div class="head">
                                <span class="head-1">个人资料</span>
                                <span class="head-2">Personal Editing</span>
                            </div>
                            <div class="cont">
                                <div class="edit-wrap">
                                    <div class="item">
                                        <div class="label">
                                            卖家头像
                                        </div>
                                        <div class="img">
                                            <img :src="personal.sellerImage" alt="" width="88" height="88">
                                        </div>
                                        <div class="txt">
                                            <el-upload
                                                    action="/student/user/image"
                                                    class="avatar-uploader"
                                                    :on-success="(response,file,fileList)=>{return handleMainAvatarSuccess(response,file,fileList,'sellerImage')}"
                                                    :show-file-list="false">

                                                <div style="display: flex;flex-direction: column;align-items: flex-start">
                                                    <span>点击上传头像</span>
                                                    <span class="info">图片格式支持PNG、JPED</span>
                                                </div>

                                            </el-upload>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="label">
                                            卖家昵称
                                        </div>
                                        <div class="img">
                                            <el-input v-model="personal.seller" placeholder="请输入卖家昵称" @blur="edit"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="edit-wrap">
                                    <div class="item">
                                        <div class="label">
                                            买家头像
                                        </div>
                                        <div class="img">
                                            <img :src="personal.buyerImage" alt="" width="88" height="88">
                                        </div>
                                        <div class="txt">
                                            <el-upload
                                                    action="/student/user/image"
                                                    class="avatar-uploader"
                                                    :on-success="(response,file,fileList)=>{return handleMainAvatarSuccess(response,file,fileList,'buyerImage')}"
                                                    :show-file-list="false">

                                                <div style="display: flex;flex-direction: column;align-items: flex-start">
                                                    <span style="color: #ff65a5 ">点击上传头像</span>
                                                    <span class="info">图片格式支持PNG、JPED</span>
                                                </div>
                                            </el-upload>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="label">
                                            买家昵称
                                        </div>
                                        <div class="img">
                                            <el-input v-model="personal.buyer" placeholder="请输入买家昵称" @blur="edit"></el-input>
                                        </div>
                                    </div>
                                    <div class="error">
                                        {{error}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot">
            闽ICP备17025076号-2 <span style="margin: 0 20px"></span>©2017-{{new Date().getFullYear()}} All rights reserved.
        </div>
    </div>
</template>

<script>
    export default {
        name: "personal",
        data() {
            return {
                personal:{},
                ConstPersonal:{},
                error:'',
                setT:''
            }
        },
        created() {
            this.getUser()
        },
        methods: {
            handleMainAvatarSuccess(res,file,list,name){
                if(res.succeed){
                    this.personal[name] = res.path;
                    this.edit()
                }
            },
            edit(){
                this.axios.post('/student/user/editor',this.personal).then(res=>{
                    if(res.succeed){
                        this.personal = res.user;
                        this.$message.success(res.message)
                        this.getUser()
                    }else {
                        this.$message.error(res.message)
                    }
                })
            },
            getUser(){
                this.axios.post('/login/current').then(res=>{
                    if(res.succeed){
                        this.ConstPersonal = JSON.parse(JSON.stringify(res.user));
                        this.personal = res.user;
                        this.$store.commit('setData',{dataKey:'user',value:res.user})
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">

    .main {
        div.main-content {
            display: flex;

            div.main-left {
                display: flex;
                flex-direction: column;
                margin-right: 28px;
                border-radius: 16px;

                div.user-img {
                    background: #FFFFFF;
                    width: 300px;
                    height: 212px;
                    border-radius: 16px;
                    padding-top: 12px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    background-image: url("./../assets/images/personal.png");
                    background-size: cover;
                    margin-bottom: 20px;

                    > img {
                        border: 2px solid #FFFFFF;
                        box-sizing: border-box;
                        border-radius: 50%;
                        box-shadow: 8px 12px 20px -6px #adadad;
                        margin-bottom: 16px;
                    }

                    > span.seller {
                        font-size: 18px;
                        font-weight: bolder;
                        margin-bottom: 10px;
                    }

                    > span.time {
                        font-size: 14px;
                        color: #9F9FA0;
                    }
                }

                div.user-info {
                    width: 300px;
                    height: 300px;
                    border-radius: 16px;
                    padding-top: 12px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    background: #FFFFFF;
                    flex-grow: 1;

                    > div {
                        width: 100%;
                        height: 60px;
                        display: flex;
                        align-items: center;
                        border-bottom: 1px solid #F1F1F1;

                        > span {
                            &.label {
                                width: 100px;
                                color: #FF66A5;
                                padding-left: 18px;
                                box-sizing: border-box;
                            }

                            &.value {
                                color: #221814;
                                box-sizing: border-box;
                                width: calc(100% - 100px);
                                text-align: right;
                                padding-right: 18px;
                                font-size: 14px;
                            }
                        }

                        &:last-child {
                            border-bottom-color: transparent;
                        }
                    }
                }
            }

            div.main-right {
                display: flex;
                flex-direction: column;
                flex-grow: 2;

                .edit-wrap {
                    padding: 20px 130px 20px 0;
                    margin-left: 130px;
                    border-bottom: 1px solid #DCDCDD;
                    &:last-child {
                        border-bottom-color: transparent;
                    }
                    .item {
                        display: flex;
                        align-items: center;
                        margin-bottom: 60px;
                        .label {
                            font-size: 18px;
                            font-weight: bolder;
                        }
                        .img {
                            margin: 0 60px;
                            > img {
                                border-radius: 50%;
                            }
                        }
                        .txt {
                            font-size: 18px;
                            font-weight: bolder;
                            display: flex;
                            flex-direction: column;
                            color: #4f57af;
                            cursor: pointer;
                             span.info {
                                margin-top: 20px;
                                font-size: 16px;
                                font-weight: normal;
                                color: #C9C9C9;
                            }
                        }
                    }
                    .error {
                        color: #f44336;
                        font-weight: bolder;
                    }
                }
            }
        }

    }

    .pagination-wrap {
        display: inline-block;

        > div.pagination {
            padding: 0 20px;
            height: 60px;
            background: #FFFFFF;
            border-radius: 10px;
            box-shadow: 3px 10px 20px -6px #b5cdd3;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
        }
    }

    div.main-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: 30px;

        > div.btnn {
            box-shadow: 0px 10px 26px -10px #9E9E9E;
            cursor: pointer;
            background: #FF65A5;
            width: 100%;
            text-align: center;
            padding: 12px;
            color: #FFFFFF;
            transition: all 0.3s linear;

            &:first-child {
                border-radius: 10px 0 0 10px;
                background: #ABD5DB;
            }

            &:last-child {
                border-radius: 0 10px 10px 0;
                background: #4149A9;
            }

            &:hover {
                transition: all 0.3s ease-in-out;
                box-shadow: 0px 10px 26px -10px #000;
            }
        }
    }

    div.foot {
        width: 100%;
        height: 30px;
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        font-size: 14px;
        color: #ABD5DB;
    }
</style>
